module.exports = __webpack_public_path__ + "img/feed_logo.91590f5a.svg";